module.exports = __webpack_public_path__ + "media/styles/images/png/select-teal-b6209ea7452c81d1756600a4edc3d083.png";